export default __webpack_public_path__ + "static/media/rejectConsentIcon.4b0a623f.png";